import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";
import './User.css';
import LoadingIndicator from "../../common/LoadingIndicator";
import {API_BASE_URL} from "../../constants";
import Alert from "react-s-alert";

class SetPasswordModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            isLoading: false,
            password: null,
        };
        this.updatePassword = this.updatePassword.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
    }

    onChangePassword(e) {
        let self = this;
        self.setState({password: e.target.value});
    }

    updatePassword() {
        let self = this;
        console.log("this.props.selectedUser", this.props.selectedUser);

        if (!this.props.selectedUser) {
            return;
        }

        if (!this.state.password || this.state.password.length < 6) {
            Alert.error(
                "En az 6 basamaklı bir şifre giriniz!", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 20000
                });
            return;
        }

        self.setState({isLoading: true});
        let params = {
            url: API_BASE_URL + "/user/set-password/" + this.props.selectedUser.recordId,
            method: 'post',
            data: this.state.password
        };
        request(params).then(() => {
            self.setState({isLoading: false});
            Alert.info(
                "İşlem Başarılı!", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 20000
                });
            self.props.cancelProcess();
        }).catch(function (error) {
            showAxiosError(error);
            self.setState({isLoading: false});
        });
    }

    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }

    render() {
        return (
            <div className='oda-form-container'>
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className='card-header'>
                    <div className="FormRenk col-sm-12">
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Kullanıcı Adı</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group"}>
                                    <input className="form-control"
                                           type="text"
                                           name="name"
                                           id="tName"
                                           data-vlength="1,50"
                                           ref="tName"
                                           value={this.props.selectedUser.username || ""}
                                           disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Yeni Şifre</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group"}>
                                    <input className="form-control"
                                           type="text"
                                           name="name"
                                           id="tName"
                                           data-vlength="1,50"
                                           ref="tName"
                                           value={this.state.password || ""}
                                           onChange={(e) => this.onChangePassword(e)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <div className='col-sm-12 row' id="deleteModal">
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"220px"}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    onClick={this.cancelProcess}>
                                İptal
                            </button>
                        </div>
                        <div className="col-sm-8"/>
                        <div className='col-sm-2'>
                            <button type="button"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    disabled={this.state.isLoading}
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right', padding: '10px 54px 10px 10px', width:"220px"
                                    }}
                                    rel="tooltip" className="TekBtn kaydet"
                                    onClick={() => this.updatePassword()}>Şifre Değişikliğini Onayla
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SetPasswordModal;



// WEBPACK FOOTER //
// ./src/page/user/SetPasswordModal.js